Vue.prototype.i18n = window.i18n;